import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { isConsumer } from 'owa-session-store';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';

export function isSchedulingAssistantEnabled(
    event: CalendarEvent | null,
    originalEvent: CalendarEvent | null
): boolean {
    const smtpOfCalendarOwner =
        event != null && event.ParentFolderId != null
            ? event.ParentFolderId.mailboxInfo.userIdentity
            : originalEvent != null && originalEvent.ParentFolderId != null
            ? originalEvent.ParentFolderId.mailboxInfo.userIdentity
            : undefined;

    return !isConsumer(smtpOfCalendarOwner) && isHostAppFeatureEnabled('schedulingAssistant');
}
